export default `vec3 q = vec3( -1.0, -1.0, 5.0 );
  vec3 d = vec3( 0.0 );
  float e = 0.0, s, u;
  e = s = 1.0;
  for( int j = 0; j++ < 6; p = cos( p ) - 0.7)
    s /= u = dot( p, p ),
    p /= -u,
    p.y = 1.72 - p.y,
    p += 0.7,
    e = min( e, p.y / s );
   return e;
}`